<template>
  <div id="payLayout">
    <h3>Выберите способ получения денег:</h3>
    <div id="selectorSet">
      <div class="item" v-bind:class="{selected:PaymentType === 'TinkoffE2C'}">
        <label for="TinkoffE2C">
          <input type="radio" v-model="PaymentType" :value="'TinkoffE2C'" id="TinkoffE2C">
          <svg width="210" height="120" viewBox="0 0 210 120" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'falseSvg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_429_29)"><path fill="#43AC34" fill-opacity=".25" d="M36 1h81.386v58.209H36z"/><path d="M111.572 1H41.813A5.817 5.817 0 0036 6.82V53.39a5.817 5.817 0 005.813 5.82h69.759a5.817 5.817 0 005.814-5.82V6.82A5.817 5.817 0 00111.572 1z" fill="#0066B2"/><path fill-rule="evenodd" clip-rule="evenodd" d="M68.22 38.774l2.89-17.293h4.619l-2.89 17.293h-4.62zm21.375-16.869c-.913-.347-2.35-.726-4.14-.726-4.566 0-7.781 2.347-7.808 5.708-.029 2.485 2.294 3.872 4.046 4.698 1.8.847 2.404 1.389 2.397 2.146-.012 1.158-1.436 1.689-2.765 1.689-1.849 0-2.832-.262-4.35-.907l-.595-.276-.646 3.871c1.077.482 3.074.9 5.147.922 4.853 0 8.007-2.318 8.044-5.907.017-1.97-1.214-3.465-3.88-4.699-1.614-.801-2.605-1.332-2.594-2.144.001-.72.837-1.488 2.647-1.488a8.357 8.357 0 013.457.664l.414.198.626-3.749zm11.85-.407h-3.57c-1.107 0-1.936.306-2.421 1.434l-6.86 15.848h4.852s.791-2.132.97-2.6c.53 0 5.245.009 5.917.009.139.603.563 2.59.563 2.59h4.287l-3.738-17.28zm-5.699 11.145c.383-.994 1.84-4.834 1.84-4.834-.027.046.381-1.002.614-1.65l.312 1.492s.886 4.127 1.069 4.992h-3.835zM64.344 21.495l-4.521 11.79-.484-2.397c-.843-2.76-3.466-5.754-6.4-7.254l4.137 15.125 4.889-.003 7.274-17.26h-4.895z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M55.551 21.18h-7.64l-.063.373c5.945 1.496 9.879 5.105 11.511 9.444l-1.66-8.295c-.286-1.144-1.119-1.483-2.148-1.523z" fill="#F79510"/></g><g clip-path="url(#clip1_429_29)"><path d="M146.656 58.866v-3.864c0-1.477-.9-2.445-2.444-2.445-.772 0-1.612.255-2.19 1.095-.45-.705-1.094-1.095-2.062-1.095-.645 0-1.289.195-1.799.9v-.772h-1.35v6.18h1.35v-3.412c0-1.096.577-1.613 1.477-1.613.9 0 1.35.577 1.35 1.613v3.413h1.349v-3.413c0-1.096.645-1.613 1.477-1.613.9 0 1.35.577 1.35 1.613v3.413h1.492zm20.021-6.181h-2.19v-1.868h-1.349v1.868h-1.223v1.222h1.223v2.836c0 1.418.577 2.25 2.122 2.25.577 0 1.222-.195 1.672-.45l-.39-1.163c-.39.255-.84.323-1.162.323-.645 0-.9-.39-.9-1.028v-2.768h2.189v-1.222h.008zm11.457-.135c-.772 0-1.289.39-1.612.9v-.773h-1.35v6.181h1.35v-3.48c0-1.028.45-1.613 1.29-1.613.255 0 .577.067.84.127l.39-1.29c-.27-.052-.653-.052-.908-.052zm-17.313.645c-.645-.45-1.545-.645-2.512-.645-1.545 0-2.572.772-2.572 1.995 0 1.028.772 1.613 2.122 1.8l.645.068c.704.127 1.094.322 1.094.645 0 .45-.517.773-1.417.773s-1.612-.323-2.062-.646l-.645 1.028c.705.518 1.672.773 2.64.773 1.799 0 2.834-.84 2.834-1.996 0-1.095-.84-1.672-2.122-1.867l-.645-.068c-.577-.068-1.027-.195-1.027-.578 0-.45.45-.705 1.162-.705.773 0 1.545.323 1.935.518l.57-1.095zm35.909-.645c-.772 0-1.29.39-1.612.9v-.773h-1.35v6.181h1.35v-3.48c0-1.028.45-1.613 1.29-1.613.255 0 .577.067.839.127l.39-1.275c-.262-.067-.644-.067-.907-.067zm-17.246 3.225c0 1.868 1.29 3.218 3.284 3.218.9 0 1.545-.195 2.19-.705l-.645-1.095c-.518.39-1.027.578-1.612.578-1.095 0-1.867-.773-1.867-1.996 0-1.163.772-1.935 1.867-1.995.577 0 1.094.195 1.612.577l.645-1.095c-.645-.517-1.29-.705-2.19-.705-1.994-.007-3.284 1.35-3.284 3.218zm12.485 0v-3.09h-1.35v.772c-.45-.577-1.095-.9-1.935-.9-1.739 0-3.089 1.35-3.089 3.218 0 1.868 1.35 3.218 3.089 3.218.9 0 1.545-.322 1.935-.9v.773h1.35v-3.09zm-4.957 0c0-1.095.705-1.995 1.867-1.995 1.095 0 1.867.84 1.867 1.995 0 1.095-.772 1.995-1.867 1.995-1.154-.067-1.867-.907-1.867-1.995zm-16.151-3.225c-1.8 0-3.089 1.29-3.089 3.218 0 1.935 1.289 3.218 3.156 3.218.9 0 1.8-.255 2.512-.84l-.645-.968c-.517.39-1.162.645-1.799.645-.84 0-1.672-.39-1.867-1.478h4.566v-.517c.06-1.988-1.102-3.278-2.834-3.278zm0 1.162c.84 0 1.417.518 1.545 1.478h-3.217c.127-.833.705-1.478 1.672-1.478zm33.532 2.063V50.24h-1.349v3.218c-.45-.577-1.095-.9-1.935-.9-1.74 0-3.089 1.35-3.089 3.218 0 1.868 1.349 3.218 3.089 3.218.9 0 1.545-.322 1.935-.9v.773h1.349v-3.09zm-4.956 0c0-1.095.705-1.995 1.867-1.995 1.095 0 1.867.84 1.867 1.995 0 1.095-.772 1.995-1.867 1.995-1.162-.067-1.867-.907-1.867-1.995zm-45.185 0v-3.09h-1.35v.772c-.45-.577-1.094-.9-1.934-.9-1.74 0-3.089 1.35-3.089 3.218 0 1.868 1.349 3.218 3.089 3.218.9 0 1.544-.322 1.934-.9v.773h1.35v-3.09zm-5.016 0c0-1.095.705-1.995 1.867-1.995 1.095 0 1.867.84 1.867 1.995 0 1.095-.772 1.995-1.867 1.995-1.162-.067-1.867-.907-1.867-1.995z" fill="#000"/><path d="M180.646 5.958h-20.275V42.4h20.275V5.96z" fill="#FF5A00"/><path d="M161.72 24.179c0-7.404 3.48-13.975 8.818-18.22A23.038 23.038 0 00156.247 1c-12.807 0-23.17 10.367-23.17 23.179 0 12.812 10.363 23.179 23.17 23.179a23.038 23.038 0 0014.291-4.959c-5.346-4.185-8.818-10.817-8.818-18.22z" fill="#EB001B"/><path d="M208 24.179c0 12.812-10.363 23.179-23.17 23.179-5.406 0-10.362-1.868-14.292-4.959 5.407-4.253 8.818-10.817 8.818-18.22 0-7.404-3.479-13.975-8.818-18.22A23.004 23.004 0 01184.823 1C197.637 1 208 11.434 208 24.179z" fill="#F79E1B"/></g><g clip-path="url(#clip2_429_29)" fill-rule="evenodd" clip-rule="evenodd"><path d="M84.349 65v.021c-.022 0-6.719-.021-8.505 6.288-1.637 5.785-6.25 21.757-6.378 22.198H68.19s-4.72-16.329-6.378-22.219C60.026 64.98 53.308 65 53.308 65H38v48h15.308V84.493h1.275L63.513 113h10.63l8.93-28.486h1.276V113h15.307V65H84.35zM140.265 65s-4.487.398-6.591 5.03l-10.843 23.477h-1.276V65h-15.308v48h14.458s4.698-.419 6.803-5.031l10.63-23.475h1.276V113h15.308V65h-14.457zM161.525 86.8V113h15.308V97.699h16.584c7.228 0 13.351-4.549 15.626-10.9h-47.518z" fill="#4DB45E"/><path d="M193.417 65h-34.039c1.701 9.139 8.653 16.475 17.646 18.865 2.042.545 4.189.838 6.4.838h26.236c.234-1.09.34-2.2.34-3.354C210 72.315 202.58 65 193.417 65z" fill="url(#paint0_linear_429_29)"/></g><defs><clipPath id="clip0_429_29"><path fill="#fff" transform="translate(36 1)" d="M0 0h81.386v58.209H0z"/></clipPath><clipPath id="clip1_429_29"><path fill="#fff" transform="translate(133.077 1)" d="M0 0h74.923v58.209H0z"/></clipPath><clipPath id="clip2_429_29"><path fill="#fff" transform="translate(38 65)" d="M0 0h172v48H0z"/></clipPath><linearGradient id="paint0_linear_429_29" x1="159.382" y1="74.852" x2="210" y2="74.852" gradientUnits="userSpaceOnUse"><stop offset=".3" stop-color="#00B4E6"/><stop offset="1" stop-color="#088CCB"/></linearGradient></defs></svg>
        </label>
      </div>
<!--      <div class="item" v-bind:class="{selected:PaymentType === 'TinkoffA2C'}">-->
<!--        <label for="TinkoffA2C">-->
<!--          <input type="radio" v-model="PaymentType" :value="'TinkoffA2C'" id="TinkoffA2C">-->
<!--          <svg fill="none" height="1255" width="2500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 233.296 120" v-bind:svg-inline="''" v-bind:class="'falseSvg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M206.665 34.254v29.338h-10.476v-20.58h-10.087v20.58h-10.476v-29.34h31.039z" fill="#000"/><path clip-rule="evenodd" d="M154.11 64.64c9.379 0 16.343-5.75 16.343-14.466 0-8.437-5.138-13.915-13.725-13.915-3.963 0-7.233 1.395-9.696 3.802.588-4.975 4.795-8.607 9.427-8.607 1.069 0 9.117-.017 9.117-.017l4.55-8.71s-10.103.23-14.8.23c-10.732.188-17.981 9.943-17.981 21.79 0 13.804 7.07 19.894 16.766 19.894zm.058-20.667c3.482 0 5.896 2.288 5.896 6.2 0 3.52-2.145 6.422-5.896 6.43-3.588 0-6.002-2.688-6.002-6.37 0-3.913 2.414-6.26 6.002-6.26z" fill="#000" fill-rule="evenodd"/><path d="M128.818 53.77s-2.474 1.426-6.17 1.696c-4.247.126-8.032-2.557-8.032-7.324 0-4.65 3.34-7.315 7.926-7.315 2.812 0 6.532 1.949 6.532 1.949s2.722-4.995 4.132-7.493c-2.582-1.957-6.021-3.03-10.021-3.03-10.095 0-17.914 6.582-17.914 15.83 0 9.366 7.349 15.795 17.914 15.6 2.953-.11 7.027-1.146 9.51-2.741z" fill="#000"/><path d="M0 26.12l14.532 25.975v15.844L.017 93.863z" fill="#5b57a2"/><path d="M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414z" fill="#d90751"/><path d="M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z" fill="#fab718"/><path d="M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z" fill="#ed6f26"/><path d="M55.797 94.007V77.322l-14.566-8.78.008 51.458z" fill="#63b22f"/><path d="M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z" fill="#1487c9"/><path d="M41.24 120l14.556-25.993 13.583-8.27 27.843-.034z" fill="#017f36"/><path d="M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922z" fill="#984995"/><g fill="#000"><path d="M114.619 83.337c-.32.408-.741.716-1.246.924a4.282 4.282 0 01-1.632.316 4.63 4.63 0 01-1.633-.274 3.623 3.623 0 01-1.262-.782 3.539 3.539 0 01-.824-1.224 4.173 4.173 0 01-.295-1.59c0-.54.093-1.04.286-1.513a3.58 3.58 0 01.79-1.224 3.88 3.88 0 011.196-.823c.463-.2.968-.308 1.523-.308.598 0 1.153.075 1.658.224.505.15.934.4 1.287.75l-.614 1.04a2.886 2.886 0 00-1.027-.6 3.612 3.612 0 00-1.12-.174c-.335 0-.655.066-.966.19a2.591 2.591 0 00-.825.534 2.438 2.438 0 00-.564.832 2.64 2.64 0 00-.21 1.08 2.621 2.621 0 00.798 1.923c.245.234.53.408.859.525a2.9 2.9 0 001.044.183c.454 0 .867-.092 1.22-.267a3.05 3.05 0 00.926-.69zm1.733 1.065v-7.405h1.33v5.517l4.325-5.517h1.33v7.406h-1.33v-5.517l-4.325 5.517h-1.33zm15.795-1.065a3.01 3.01 0 01-1.245.924 4.291 4.291 0 01-1.633.316 4.628 4.628 0 01-1.632-.274 3.627 3.627 0 01-1.263-.782 3.539 3.539 0 01-.824-1.224 4.173 4.173 0 01-.295-1.59c0-.54.093-1.04.286-1.513.186-.475.455-.882.79-1.224a3.88 3.88 0 011.196-.823 3.637 3.637 0 011.523-.308c.598 0 1.153.075 1.658.224.505.15.934.4 1.288.75l-.615 1.04a2.874 2.874 0 00-1.026-.6 3.616 3.616 0 00-1.12-.174 2.603 2.603 0 00-1.792.724 2.536 2.536 0 00-.564.832 2.64 2.64 0 00-.21 1.08 2.621 2.621 0 00.799 1.923c.244.234.53.408.859.525.328.116.673.183 1.043.183.455 0 .859-.092 1.22-.267a3.05 3.05 0 00.926-.69zm.682-6.34h6.824v1.315h-2.743v6.09h-1.33v-6.09h-2.743v-1.315z"/><path clip-rule="evenodd" d="M145.864 84.328c.505-.158.934-.4 1.304-.732l-.404-1.032c-.244.217-.572.4-.967.55-.396.15-.842.224-1.33.224-.732 0-1.338-.191-1.818-.582-.48-.392-.74-.94-.8-1.64h5.757a4 4 0 00.084-.89 3.35 3.35 0 00-.278-1.381 3.277 3.277 0 00-.74-1.074 3.295 3.295 0 00-1.111-.69 3.692 3.692 0 00-1.355-.25c-.623 0-1.17.108-1.65.308a3.637 3.637 0 00-1.203.824 3.477 3.477 0 00-.748 1.223 4.272 4.272 0 00-.261 1.514c0 .583.1 1.115.286 1.59a3.5 3.5 0 00.808 1.223c.345.34.765.599 1.262.782a4.772 4.772 0 001.658.274 5.04 5.04 0 001.506-.24zm-3.366-5.7c.412-.374.959-.557 1.649-.557.648 0 1.17.175 1.549.525.379.349.58.832.614 1.447h-4.544a2.26 2.26 0 01.732-1.414z" fill-rule="evenodd"/><path d="M149.499 76.997h1.212l2.878 3.67 2.726-3.67h1.178v7.406h-1.33v-5.4l-2.591 3.436h-.051l-2.692-3.437v5.4h-1.33z"/><path clip-rule="evenodd" d="M161.11 77.022a4.187 4.187 0 00-1.143.49l.353 1.05c.303-.15.606-.275.909-.383.303-.11.69-.16 1.153-.16.37 0 .665.06.892.176.227.108.395.275.513.475s.194.449.236.74.059.607.059.949a2.28 2.28 0 00-.91-.375 5.229 5.229 0 00-.958-.1c-.396 0-.766.059-1.12.158-.353.1-.656.25-.9.45a2.14 2.14 0 00-.59.74 2.3 2.3 0 00-.218 1.007c0 .724.21 1.29.63 1.69.422.399.977.598 1.667.598.623 0 1.12-.108 1.498-.324.379-.217.682-.466.9-.75v.958h1.246v-4.543c0-.966-.21-1.714-.64-2.24-.42-.523-1.17-.79-2.23-.79a5.08 5.08 0 00-1.346.184zm2.224 6c-.303.216-.7.315-1.187.315-.43 0-.766-.108-1.001-.316-.236-.216-.354-.5-.354-.85 0-.206.042-.381.135-.54s.219-.282.362-.382a1.6 1.6 0 01.513-.225c.194-.05.387-.075.589-.075.657 0 1.22.158 1.683.49v.94a3.824 3.824 0 01-.74.642zm13.733-8.63c.269-.124.52-.332.757-.64l-.724-1.04c-.185.25-.395.424-.631.516a4.007 4.007 0 01-.774.216l-.252.045c-.22.038-.454.08-.707.122a5.224 5.224 0 00-1.178.366c-.598.258-1.077.607-1.44 1.048s-.647.94-.841 1.49a7.793 7.793 0 00-.395 1.722c-.068.6-.101 1.173-.101 1.722 0 .708.092 1.348.277 1.922.186.575.446 1.057.79 1.448.346.4.759.7 1.247.916s1.035.324 1.649.324c.564 0 1.086-.108 1.557-.308a3.758 3.758 0 001.212-.823c.336-.342.606-.75.79-1.207a3.74 3.74 0 00.287-1.465c0-.557-.084-1.064-.244-1.514a3.271 3.271 0 00-.69-1.156 3.072 3.072 0 00-1.103-.75 3.827 3.827 0 00-1.447-.266c-.32 0-.631.042-.934.125a3.604 3.604 0 00-.842.358 3.2 3.2 0 00-.698.54c-.202.209-.37.442-.488.708h-.034a8.07 8.07 0 01.143-1.048c.076-.358.185-.7.329-1.024.143-.324.328-.616.555-.882a2.52 2.52 0 01.875-.624 4.646 4.646 0 011.153-.374l.264-.048c.263-.048.514-.094.754-.144.32-.066.614-.15.884-.274zm-4.68 7.115a4.146 4.146 0 01-.184-1.298 2.09 2.09 0 01.303-.707 2.48 2.48 0 01.547-.6 2.773 2.773 0 011.733-.59c.783 0 1.372.24 1.784.716.413.482.615 1.08.615 1.805 0 .358-.068.683-.185.982a2.36 2.36 0 01-1.28 1.323c-.302.133-.631.2-1.001.2s-.707-.075-1.018-.225a2.34 2.34 0 01-.8-.624 3.129 3.129 0 01-.513-.982zm16.402-4.51h-1.33v7.406h1.33zm-8.281 0h1.33v2.222h1.229c.58 0 1.05.075 1.43.216.379.142.682.333.909.566s.387.508.48.815c.092.308.143.624.143.957s-.051.65-.16.966c-.101.316-.278.59-.514.84-.235.25-.555.45-.96.6-.403.149-.891.232-1.48.232H180.5v-7.414zm1.33 3.46v2.714h.968c.665 0 1.136-.116 1.405-.35.27-.233.404-.565.404-1.006 0-.45-.143-.79-.412-1.024-.278-.233-.741-.35-1.38-.35h-.985z" fill-rule="evenodd"/><path d="M197.583 83.337c-.32.408-.741.716-1.246.924a4.286 4.286 0 01-1.632.316 4.63 4.63 0 01-1.633-.274 3.613 3.613 0 01-1.262-.782 3.555 3.555 0 01-.825-1.224 4.192 4.192 0 01-.294-1.59c0-.54.092-1.04.286-1.513a3.58 3.58 0 01.79-1.224c.338-.35.74-.615 1.196-.823a3.634 3.634 0 011.523-.308c.597 0 1.153.075 1.658.224.505.15.934.4 1.287.75l-.614 1.04a2.886 2.886 0 00-1.027-.6 3.612 3.612 0 00-1.12-.174 2.59 2.59 0 00-.967.19 2.587 2.587 0 00-.824.534 2.52 2.52 0 00-.564.832 2.64 2.64 0 00-.21 1.08 2.621 2.621 0 00.798 1.923c.245.234.53.408.859.525.329.116.674.183 1.044.183a2.76 2.76 0 001.22-.267 3.05 3.05 0 00.926-.69zm.68-6.34h6.826v1.315h-2.744v6.09h-1.33v-6.09h-2.742v-1.315z"/><path clip-rule="evenodd" d="M207.866 76.998h-1.33v10.7h1.33v-3.636c.269.175.589.3.959.383s.757.124 1.153.124c.589 0 1.119-.108 1.599-.307a3.825 3.825 0 001.228-.84 3.65 3.65 0 00.79-1.266c.186-.49.279-1.015.279-1.572 0-.55-.084-1.057-.244-1.515a3.524 3.524 0 00-.69-1.181 2.996 2.996 0 00-1.086-.774 3.49 3.49 0 00-1.44-.283c-.52 0-1.008.1-1.471.3s-.825.44-1.077.74zm.926 1.373c.379-.2.79-.3 1.237-.3.387 0 .732.058 1.044.183.303.125.555.3.766.533.21.233.37.5.47.815.11.316.16.658.16 1.032 0 .4-.067.757-.184 1.09a2.4 2.4 0 01-.514.849 2.36 2.36 0 01-.816.557 2.685 2.685 0 01-1.086.208c-.361 0-.698-.041-1.018-.124a3.328 3.328 0 01-.984-.45v-3.67c.235-.282.547-.523.925-.723zm15.28-1.374h-1.33v7.406h1.33zm-8.288 0h1.33v2.222h1.228c.58 0 1.052.075 1.43.216.38.142.683.333.91.566s.387.508.479.815c.093.308.143.624.143.957s-.05.65-.16.966c-.1.316-.277.59-.513.84-.235.25-.555.45-.96.6-.403.149-.891.232-1.48.232h-2.415v-7.414zm1.339 3.46v2.714h.968c.664 0 1.136-.116 1.405-.35.269-.233.404-.565.404-1.006 0-.45-.143-.79-.412-1.024-.278-.233-.741-.35-1.38-.35h-.985z" fill-rule="evenodd"/><path d="M230.452 80.567l2.844 3.836h-1.632l-2.197-2.996-2.23 2.996h-1.548l2.827-3.77-2.66-3.636h1.634l2.028 2.796 2.06-2.796h1.55zM113.635 93.556h-4.081v6.174h-1.33v-7.405h6.74v7.405h-1.33zm8.877.083h-2.625l-.085 1.248c-.092 1.057-.218 1.906-.395 2.554-.177.65-.396 1.149-.648 1.498-.252.35-.547.59-.884.708a3.06 3.06 0 01-1.085.183l-.101-1.282a1.08 1.08 0 00.496-.108c.186-.083.37-.266.547-.54.177-.284.337-.683.48-1.2.143-.523.236-1.205.286-2.063l.135-2.305h5.209v7.406h-1.33v-6.1z"/><path clip-rule="evenodd" d="M127.427 92.342c-.43.116-.817.282-1.145.49l.354 1.049c.303-.15.606-.275.908-.383.303-.108.69-.158 1.153-.158.37 0 .665.058.892.174.228.109.396.275.514.475.117.2.193.45.235.74.042.292.059.608.059.949a2.277 2.277 0 00-.91-.374 5.22 5.22 0 00-.958-.1 4.09 4.09 0 00-1.12.158c-.353.1-.656.25-.9.45a2.14 2.14 0 00-.59.74 2.3 2.3 0 00-.217 1.007c0 .723.21 1.29.63 1.689.42.399.977.599 1.667.599.623 0 1.119-.108 1.498-.325.378-.216.68-.466.9-.75v.958h1.246v-4.543c0-.965-.211-1.714-.64-2.238-.421-.525-1.17-.79-2.23-.79a5.1 5.1 0 00-1.346.182zm2.23 5.998c-.302.217-.698.317-1.186.317-.438 0-.766-.108-1.001-.317-.236-.216-.354-.5-.354-.848 0-.208.042-.383.135-.541.092-.158.219-.283.362-.383s.319-.175.513-.225a2.33 2.33 0 01.589-.074c.656 0 1.22.158 1.683.49v.94a3.83 3.83 0 01-.741.64z" fill-rule="evenodd"/><path d="M132.946 92.325h6.825v1.314h-2.744v6.09h-1.33v-6.09h-2.742v-1.314z"/><path clip-rule="evenodd" d="M145.982 99.655c.505-.158.934-.4 1.304-.732l-.404-1.032c-.244.217-.572.4-.968.55-.395.15-.841.224-1.33.224-.731 0-1.337-.191-1.817-.582s-.74-.94-.8-1.64h5.757a4.06 4.06 0 00.084-.89c0-.507-.093-.965-.278-1.381a3.264 3.264 0 00-.741-1.073 3.28 3.28 0 00-1.11-.691 3.696 3.696 0 00-1.355-.25c-.623 0-1.17.108-1.65.308a3.618 3.618 0 00-1.203.824 3.494 3.494 0 00-.75 1.223 4.294 4.294 0 00-.26 1.514c0 .583.1 1.115.286 1.59.186.474.463.882.808 1.223s.766.599 1.263.782a4.766 4.766 0 001.657.275c.497 0 1.002-.084 1.507-.242zm-3.374-5.708c.412-.374.959-.557 1.649-.557.657 0 1.17.183 1.549.524.378.35.58.832.614 1.448h-4.544a2.26 2.26 0 01.732-1.415zm5.848-1.622h1.683l2.566 3.57-2.743 3.835h-1.632l2.877-3.836-2.751-3.57zm4.577 0h1.33v7.405h-1.33zm6.084 7.405l-2.928-3.836 2.735-3.57h-1.65l-2.583 3.57 2.777 3.836zm6.076-.075c.505-.158.934-.4 1.304-.732l-.404-1.032c-.244.217-.572.4-.967.55-.396.15-.842.224-1.33.224-.732 0-1.338-.191-1.818-.582-.48-.391-.74-.94-.8-1.64h5.757a4 4 0 00.084-.89c0-.507-.092-.965-.278-1.381a3.276 3.276 0 00-.74-1.073 3.284 3.284 0 00-1.111-.691 3.692 3.692 0 00-1.355-.25 4.25 4.25 0 00-1.65.308 3.624 3.624 0 00-1.202.824 3.465 3.465 0 00-.75 1.223 4.272 4.272 0 00-.26 1.514c0 .583.1 1.115.286 1.59.185.474.463.882.808 1.223s.765.599 1.262.782a4.772 4.772 0 001.658.275 5.04 5.04 0 001.506-.242zm-3.374-5.708c.413-.374.96-.557 1.65-.557.648 0 1.169.183 1.548.524.379.35.58.832.614 1.448h-4.544a2.26 2.26 0 01.732-1.415zm10.595-4.11c-.783 0-1.212-.433-1.28-1.298h-1.253c0 .332.059.632.168.915.11.283.27.524.48.724s.48.358.79.482c.312.125.674.183 1.086.183a2.64 2.64 0 001.019-.183c.303-.116.555-.282.774-.482a2.1 2.1 0 00.496-.724c.118-.283.177-.583.177-.915h-1.245c-.06.865-.472 1.298-1.212 1.298zm-3.594 2.487v7.406h1.33l4.325-5.517v5.517h1.33v-7.406h-1.33l-4.325 5.517v-5.517z" fill-rule="evenodd"/></g></svg>-->
<!--        </label>-->
<!--      </div>-->
    </div>

    <div id="selectorGet">
      <div v-show="PaymentType === 'TinkoffE2C'">
        <div id="issetCard">
          <div v-if="tinkoffE2C.length > 0">
            <h3>Выберите свою карту</h3>
            <div id="issetCardLayout">
              <div
                v-for="(item,index) in tinkoffE2C"
                :key="index"
                class="item"
                v-bind:class="{selected:item.cardId === tinkoffE2C_cardSelected.cardId}"
              >
                <label :for="'card_' + index">
                  <input type="radio" v-model="tinkoffE2C_cardSelected" :value="item" :id="'card_' + index">
                  <div class="cardView">
                    <img svg-inline :src=item.cardType alt="" class="falseSvg">
                    <span>{{item.pan}}</span>
                  </div>

                </label>
              </div>
            </div>
          </div>
          <div class="item" v-on:click="addTinkoffE2C">
            <label for="">
              <span></span>
              <span>Добавить новую карту</span>
            </label>
          </div>
        </div>

        <iframe id="tkFrame" :src="addTinkoffE2CURL" frameborder="0" v-if="addTinkoffE2CURL.length > 0"
                style="width: 100%;height: 600px"></iframe>
      </div>
      <div v-show="PaymentType === 'TinkoffA2C'">
        <h3>Система быстрых платежей</h3>
        <h4>Выберите Ваш банк:</h4>
        <div id="bankElected">
          <div v-for="(item,index) in bankListComputedElected" :key="index"  class="itemElected"
               v-bind:class="{selected:item.memberId === tinkoffA2C_bankSelected.memberId}"
          >
            <label :for="'bank_'+index">
              <input type="radio" v-model="tinkoffA2C_bankSelected" :value="item" :id="'bank_'+index">
              <img svg-inline :src="item.img">
            </label>
          </div>
        </div>



        <h4>Найти другой банк:</h4>
        <formInput :refs="'finderBankSbp'" :required="false"></formInput>
        <div id="bankName">
          <div v-for="(item,index) in bankListComputed" :key="index"  class="item">
            <label :for="'bank_'+index">
              <input type="radio" v-model="tinkoffA2C_bankSelected" :value="item" :id="'bank_'+index">
              <span>{{item.memberNameRus}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: "formScreenPaymentSelector",
    data(){
      return {
        tinkoffE2C:[],
        addTinkoffE2CURL:'',
        bankList:[],
        clientId:0,
        cardIcon: {
          masterCard: require('@/assets/vector/cardTypesLogo/Mastercard.svg'),
          MIR: require('@/assets/vector/cardTypesLogo/MIR.svg'),
          visa: require('@/assets/vector/cardTypesLogo/visa.svg'),
          AmericanExpress: require('@/assets/vector/cardTypesLogo/amex.svg'),
          JCB: require('@/assets/vector/cardTypesLogo/JCB.svg'),
          International: require('@/assets/vector/cardTypesLogo/ICS.svg'),
          DinersClub: require('@/assets/vector/cardTypesLogo/dinersClub.svg'),
          Maestro: require('@/assets/vector/cardTypesLogo/maestro.svg'),
          Discover: require('@/assets/vector/cardTypesLogo/discover.svg'),
          UEK: require('@/assets/vector/cardTypesLogo/Mastercard.svg'),
          chinaUnionPay: require('@/assets/vector/cardTypesLogo/chinaUnionPay.svg')
        },
        bankIcons: {
          100000000111: require('@/assets/vector/bankIcons/sber.svg'),
          100000000008: require('@/assets/vector/bankIcons/alfa.svg'),
          100000000005: require('@/assets/vector/bankIcons/VTB.svg'),
          100000000010: require('@/assets/vector/bankIcons/PSB.svg'),
          100000000004: require('@/assets/vector/bankIcons/tinkoff.svg'),
          100000000024: require('@/assets/vector/bankIcons/HKB.svg'),
        }
      }
    },
    components:{
      formInput:        () => import('@/views/pdlloan/formInput'),
    },
    computed:{
      ...mapState({
        vuexPaymentType: state=>state.Form.sendData.PAYMENT_TYPE,
        vuexfinderBankSbp: state=>state.Form.sendData.finderBankSbp,
        vuexBankSelected: state=>state.Form.sendData.tinkoffA2C_bankSelected,
        vuexCardSelected: state=>state.Form.sendData.tinkoffE2C_cardSelected,
      }),
      tinkoffE2C_cardSelected: {
        get(){
          return this.vuexCardSelected;
        },
        set(newValue) {
          this.$external.traceInput({
            action:165,
            refs:'tinkoffE2C_cardSelected',
            value:newValue
          });
          this.$store.dispatch('saveSendData',{
            target:'tinkoffE2C_cardSelected',
            value: newValue
          });
        }
      },
      tinkoffA2C_bankSelected: {
        get() {
          return this.vuexBankSelected;
        },
        set(newValue) {
          this.$external.traceInput({
            action:165,
            refs:'tinkoffA2C_bankSelected',
            value:newValue
          });
          this.$store.dispatch('saveSendData',{
            target:'tinkoffA2C_bankSelected',
            value: newValue
          });
        }
      },
      PaymentType:{
        get(){
          return this.vuexPaymentType;
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'PAYMENT_TYPE',
            value: value
          });
          this.$external.traceInput({
            action:165,
            refs:'PAYMENT_TYPE',
            value:value
          });
        }
      },
      /**
       * формирует список банков с учетом ввода поля поиска банка
       * @returns {[]}
       */
      bankListComputed(){
        let out = [];
        if (this.vuexfinderBankSbp.length > 0) {
          out =  this.bankList.filter((item)=>{
            return item.finderStr.indexOf(this.vuexfinderBankSbp.toLowerCase()) >= 0
          });
        }
        return out;
      },
      bankListComputedElected() {
        let outElected = [];
        if (this.bankList.length > 0) {
          for( let i = 0; i<this.bankList.length; i++) {
            if (this.bankIcons[this.bankList[i].memberId] !== undefined) {
              let bankObj = this.bankList[i]
              bankObj['img'] = this.bankIcons[this.bankList[i].memberId]
              outElected.push(bankObj)
            }
          }
        }
        return outElected
      },
    },
    methods:{
      getTinkoffA2C(){
        this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_TINKOF,
          data:{
            action:'get-sbp-members',
            session_id: window.session_id,
          }
        }).then(res=>{
          let tmpBankList = res.data.members.sort((a,b)=>{
            let left = a.memberNameRus.toString().toLowerCase();
            let right = b.memberNameRus.toString().toLowerCase();
            if (left < right) return -1;
            if (left > right) return 1;
            return 0
          });


          for(let i= 0; i < tmpBankList.length; i+=1 ){

            tmpBankList[i]['finderStr'] =  tmpBankList[i].memberName.toLowerCase() + ' ' + tmpBankList[i].memberNameRus.toLowerCase();
          }
          this.bankList = tmpBankList;

        }).catch(res=>{
          console.log(res);
        })

      },
      getTinkoffE2C(){
        return new Promise((resolve => {
          this.$axios({
            method: 'post',
            url: process.env.VUE_APP_URL_TINKOF,
            data:{
              action:'getTinkoffE2C',
              clientId:this.clientId,
              session_id:window.session_id,
            }
          }).then((res)=>{
            let tempCountCard = this.tinkoffE2C.length;
            this.tinkoffE2C = res.data.cardList;
            for (let i=0; i < this.tinkoffE2C.length; i++) {
              let firstFour = this.tinkoffE2C[i].pan.slice(0,4)
              this.tinkoffE2C[i]['cardType'] = this.cardTypeIdentify(firstFour);
            }
            if (tempCountCard !== this.tinkoffE2C.length && this.addTinkoffE2CURL.length > 0) {
              this.addTinkoffE2CURL = '';
              document.getElementById('issetCard').scrollIntoView({
                behavior: 'smooth',
              });
            }
          }).catch((res)=>console.log(res)).finally(()=>resolve());
        }));
      },

      cardTypeIdentify(value) {
        let out = ''
        let deep = value.slice(1,2)
        switch (value.slice(0,1)) {
          case '2': {
            out = this.cardIcon.MIR
          } break;
          case '3': {
            if ( deep === '0' || deep === '6' || deep === '8' ) {
              out = this.cardIcon.DinersClub
            } else if ( deep === '1' || deep === '5') {
              out = this.cardIcon.International
            } else if ( deep === '4' || deep === '7' ) {
              out = this.cardIcon.AmericanExpress
            }
          } break;
          case '4': {
            out = this.cardIcon.visa
          } break;
          case '5': {
            if ( deep === '0' || deep === '6' || deep === '7' || deep === '8' ) {
              out = this.cardIcon.Maestro
            } else if ( deep === '1' || deep === '2' || deep === '3' || deep === '4' || deep === '5') {
              out = this.cardIcon.masterCard
            }
          } break;
          case '6': {
            if ( deep === '0' ) {
              out = this.cardIcon.Discover
            } else if ( deep === '2') {
              out = this.cardIcon.chinaUnionPay
            } else if ( deep === '3' || deep === '7' ) {
              out = this.cardIcon.Maestro
            }
          } break;
          case '7': {
            out = this.cardIcon.UEK
          } break;
          default: out = ''
        }
        // out = this.cardIcon.Discover
        return out
      },
      addTinkoffE2C(){
        this.$axios({
          method: 'post',
          url: process.env.VUE_APP_URL_TINKOF,
          data:{
            action:'addTinkoffE2C',
            clientId:this.clientId,
            session_id: window.session_id,
          }
        }).then((res)=>{
          this.addTinkoffE2CURL = res.data.paymentURL;
          setTimeout(()=>{
            document.getElementById('tkFrame').scrollIntoView({
              behavior: 'smooth',
            });
          },300)
        }).catch((res)=>console.log(res));
      },
      tryCathUpdateFromTinkof(){
        if (this.addTinkoffE2CURL.length > 0) {
          this.getTinkoffE2C().then(()=>{
            setTimeout(()=>{
              this.tryCathUpdateFromTinkof();
            },3000);
          })
        }
      }
    },
    watch:{
      PaymentType(newValue){
        //todo watch плохая идея запрос дублит при хуке mounted
        if (newValue === 'TinkoffE2C') {
          this.getTinkoffE2C();
        }
        if (newValue === 'TinkoffA2C'){
          this.getTinkoffA2C();
        }
        this.$external.traceInput({
          action:165,
          refs:'PAYMENT_TYPE',
          value:newValue
        });
      },
      addTinkoffE2CURL(newValue){
        if (newValue.length > 0) {
          this.tryCathUpdateFromTinkof();
        }
      },
    },
    mounted(){
      this.$emit('scrollingTo', {
        id:'zform',
      });
//todo заблокировать проход на следующий экран
      this.clientId = parseInt(localStorage.getItem('cid'));
      if (this.clientId <= 0 || isNaN(this.clientId)){
        alert('ошибка подключения к банку sid='+window.session_id);
      } else {
        this.getTinkoffE2C();
        this.getTinkoffA2C();

        // //костыль что бы сразу показать карту, ткак как сбп временно отключаем
        // this.$store.dispatch('saveSendData',{
        //   target:'PAYMENT_TYPE',
        //   value: 'TinkoffE2C'
        // });
        // this.$external.traceInput({
        //   action:165,
        //   refs:'PAYMENT_TYPE',
        //   value:'TinkoffE2C'
        // });
      }
    }
  }
</script>

<style scoped>
  input { width: auto }
  h3 { margin-bottom: 20vw }
  #payLayout {width: 100%}
  .item { border: 1px solid transparent;border-radius: 9px;box-shadow: 0 4px 4px #00000040;transition: 0.3s ease-out;cursor: pointer;margin-bottom: 2.94vw }
  .item:hover, .item.selected {background: rgba(67, 172, 52, 0.25);border:1px solid #43AC34}
  .item label{display: flex;align-items: center;justify-content: space-around;width: 100%;height: 100%;cursor: pointer;}
  .itemElected { border: 1px solid transparent;border-radius: 9px;box-shadow: 0 4px 4px #00000040;transition: 0.3s ease-out;cursor: pointer;margin-bottom: 2.94vw }
  .itemElected:hover, .itemElected.selected {background: rgba(67, 172, 52, 0.25);border:1px solid #43AC34}
  .itemElected label{display: flex;align-items: center;justify-content: space-around;width: 100%;height: 100%;cursor: pointer;}
  .itemElected label img { width: 58.82vw; height: 10.59vw }
  .cardView{display: flex;flex-direction: column;align-items: flex-end;justify-content: space-around;height: 100%; width: 62vw}
  .cardView img{width: 22.06vw;height: 17.35vw}
  #selectorSet, #issetCardLayout,#selectorGet
  {display: flex;align-items: center;justify-content: space-between; flex-direction: column;}
  #selectorSet .item, #selectorGet .item{width: 90.88vw;height: 47.06vw;}
  #selectorSet .itemElected, #selectorGet .itemElected{width: 90.88vw;height: 47.06vw;}
  #selectorSet .item svg{width: 61.76vw;height: 35.29vw;outline:none;}
  #selectorSet .itemElected svg{width: 61.76vw;height: 35.29vw;outline:none;}
  #bankElected {display: flex; flex-wrap: wrap }
  #bankName{display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap}
  #bankName .item{height:auto;padding: 4.41vw 0}
  #bankElected .itemElected{height:auto;padding: 4.41vw 0}
  #bankName .item span{width: 76.47vw}
  #bankElected .itemElected span{width: 76.47vw}
  @media (min-width: 760px) {
    h3 { margin-bottom: 3.23vw }
    #selectorSet, #issetCardLayout,#selectorGet
    {width: 51.61vw; flex-direction: row;}
    #selectorSet .item, #selectorGet .item{width: 24.92vw;height: 12.90vw;}
    #selectorSet .itemElected, #selectorGet .itemElected{width: 24.92vw;height: 12.90vw;}
    #selectorSet .item svg{width: 16.94vw;height: 9.68vw}
    #selectorSet .itemElected svg{width: 16.94vw;height: 9.68vw}


    .item{box-shadow: 0 4px 4px #00000040; margin-bottom: 0.81vw}
    .item:hover, .item.selected {}
    .item label{}

    .itemElected{box-shadow: 0 4px 4px #00000040; margin-bottom: 0.81vw}
    .itemElected:hover, .itemElected.selected {}
    .itemElected label{}
    .itemElected label img { width: 16.13vw; height: 3.54vw }

    .cardView{ width: 16.27vw }
    .cardView img{width: 75px;height: 59px}

    #bankName{}
    #bankName .item{padding: 15px 0;height: auto}
    #bankElected .itemElected{padding: 15px 0;height: auto}
    #bankName .item span{width: 260px}
    #bankElected .itemElected span{width: 260px}
  }
  @media (min-width: 1240px) {
    #selectorSet, #issetCardLayout {width: 640px}
    #selectorGet{width: 100%}
    #selectorSet .itemElected, #selectorGet .itemElected{width: 211px;height: 65px;}
    #selectorSet .item, #selectorGet .item{width: 309px;height: 160px;}
    #selectorSet .item svg{width: 210px;height: 120px}
    #selectorSet .itemElected svg{width: 210px;height: 120px}


    .item{box-shadow: 0 4px 4px #00000040; margin-bottom: 10px}
    .item:hover, .item.selected {}
    .item label{}

    .itemElected{box-shadow: 0 4px 4px #00000040; margin-bottom: 10px}
    .itemElected:hover, .itemElected.selected {}
    .itemElected label{}
    .itemElected label img { width: 150px; height: 60px }
    .itemElected:nth-child(1) label img { height: 31px; padding-top: 10px }
    .itemElected:nth-child(2) label img { height: 31px; padding-bottom: 4px }
    .itemElected:nth-child(3) label img { height: 31px }

    .cardView{ width: 196px }
    .cardView img{width: 75px;height: 59px}

    #bankName{}
    #bankName .item{padding: 15px 0;height: auto}
    #bankElected .itemElected{padding: 15px 0}
    #bankName .item span{width: 260px}
    #bankElected .itemElected span{width: 260px}
  }
</style>

<!--2-Мир-->
<!--3- American Express, JCB International, Diners Club-->
<!--____30,36,38-Diners Club-->
<!--____31,35-JCB International-->
<!--____34,37-American Express-->
<!--4- VISA-->
<!--5- MasterCard, Maestro-->
<!--____50,56,57,58-Maestro-->
<!--____51,52,53,54,55-MasterCard-->
<!--6- Maestro, China UnionPay, Discover-->
<!--____60-Discover-->
<!--____62 - China UnionPay-->
<!--____63, 67 - Maestro-->
<!--7-УЭК-->
